import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appEscapeKeyDirective]',
})
export class EscapeKeyDirectiveDirective {
  @Output() public escapeKeyPressed = new EventEmitter<void>();

  @HostListener('document:keydown.escape', ['$event'])
  public handleEscapeKey(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;
    console.debug(keyboardEvent);
    this.escapeKeyPressed.emit();
  }
}
